import comboHandler from "./combo.handler";
import skeletonHandler from "./skeleton.handler";
import d22Handler from "./d22.handler";
import d28Handler from "./d28.handler";
import d39Handler from "./d39.handler";
import d45handler from "./d45.handler";
import d53handler from "./d53.handler";
import d108handler from "./d108.handler";
import d138Handler from "./d138.handler";
import looklab20240909Handler from "./looklab_20240909.handler";
import looklab20240909ScreamHandler from "./looklab_20240909_scream.handler";
import ipadapterHandler from "./ipadapter.handler";

export const handlersNames = {
  SKELETON: "skeleton",
  COMBO: "combo",
  D22: "d22",
  D28: "d28",
  D39: "d39",
  D45: "d45",
  D53: "d53",
  D108: "d108",
  D138: "d138",
  looklab20240909: "looklab_20240909",
  looklab20240909Scream: "looklab_20240909_scream",
  ipadapter: "ipadapter",
};

const handlersMap = {
  [handlersNames.SKELETON]: skeletonHandler,
  [handlersNames.COMBO]: comboHandler,
  [handlersNames.D22]: d22Handler,
  [handlersNames.D28]: d28Handler,
  [handlersNames.D39]: d39Handler,
  [handlersNames.D45]: d45handler,
  [handlersNames.D53]: d53handler,
  [handlersNames.D108]: d108handler,
  [handlersNames.D138]: d138Handler,
  [handlersNames.looklab20240909]: looklab20240909Handler,
  [handlersNames.looklab20240909Scream]: looklab20240909ScreamHandler,
  [handlersNames.ipadapter]: ipadapterHandler,
};

export function getHandlerByName(name) {
  return handlersMap[name] || null;
}